import React, { useEffect, useState } from "react";
import ManagePrivilegeAccountHeader from "../../components/PrivilegeAccounts/ManagePrivilegeAccountHeader";
import { useNavigate, useParams } from "react-router-dom";
import PrivilegeAccountForm from "../../components/PrivilegeAccounts/ManagePrivilegeAccountForm";
import { getSettings } from "../../services/settingsService";
import {
  getFormattedAccountData,
  getFormattedPostableAccountData,
  getFormattedSelectFields,
  validateAccountData,
} from "../../helper";
import { ToastMessage } from "../../components/ToastMessage";
import { toast } from "react-toastify";
import { uploadEventImage } from "../../services/eventsService";
import {
  addPrivilege,
  fetchPrivilegeFromId,
  updatePrivilege,
} from "../../services/privilegeService";
import { useLoadContext } from "../../contexts/LoadContext";

const ManagePrivilegeAccount = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [accountDetails, setAccountDetails] = useState({
    type: "",
    name: "",
    isActive: false,
    benefits: [""],
    percentage: 0,
    qrLineColor: "FFF",
    badgeHomeImg: new Array<string>(),
    badgeProfileImg: new Array<string>(),
    bgMenuImg: new Array<string>(),
    bgHomeImg: new Array<string>(),
    nameTextColor: "",
    benefitsFile: new Array<string>(),
  });

  const [formError, setFormError] = useState({
    type: "",
    name: "",
    isActive: "",
    benefits: "",
    percentage: "",
    qrLineColor: "",
    badgeHomeImg: "",
    badgeProfileImg: "",
    bgMenuImg: "",
    bgHomeImg: "",
    nameTextColor: "",
  });

  const [accountTypes, setAccountTypes] = useState([]);
  const [uploadedImage, setUploadedImage] = useState();
  const { setLoader } = useLoadContext();

  useEffect(() => {
    if (id) {
      fetchData();
    }
  }, []);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchData = async () => {
    setLoader(true);
    try {
      let accountRes = await fetchPrivilegeFromId(id);
      setAccountDetails(getFormattedAccountData(accountRes?.data?.data));
    } catch (err: any) {
      toast.error(err.message);
    } finally {
      setLoader(false);
    }
  };

  const fetchSettings = async () => {
    setLoader(true);
    try {
      let settings = await getSettings("cms");
      setAccountTypes(
        getFormattedSelectFields(settings?.data?.data?.promotion_tags)
      );
    } catch (err: any) {
      toast.error(err.message);
    } finally {
      setLoader(false);
    }
  };

  const handleChange = (e: any, index: any) => {
    let { name, value } = e.target;
    setFormError({ ...formError, [name]: "" });
    if (
      name === "badgeHomeImg" ||
      name === "badgeProfileImg" ||
      name === "bgHomeImg" ||
      name === "bgMenuImg"
    ) {
      uploadEvent(e);
    } else if (name === "benefitsFile") {
      uploadPDF(e);
    } else if (name === "benefits") {
      let accountDetailsClone = { ...accountDetails };
      accountDetailsClone.benefits[index] = value;
      setAccountDetails(accountDetailsClone);
    } else {
      setAccountDetails({ ...accountDetails, [name]: value });
    }
  };

  const handleAddMoreBenefits = () => {
    let accountDetailsClone = { ...accountDetails };
    accountDetailsClone.benefits.push("");
    setAccountDetails(accountDetailsClone);
  };

  const uploadPDF = async (event: any) => {
    let formData = { ...accountDetails };
    let maxImageSize = 2048756;
    if (
      event.target.name === "benefitsFile" &&
      event.target.files[0].size > maxImageSize
    ) {
      toast.error(
        <ToastMessage message="Only JPEG or PNG files are allowed. Max size: 2MB." />,
        {
          hideProgressBar: true,
        }
      );
    } else {
      try {
        let { data } = await uploadEventImage(event.target.files[0]);

        formData["benefitsFile"] = [];
        formData["benefitsFile"].push(data.files[0]);
        setAccountDetails(formData);
      } catch (err) {
        toast.error(<ToastMessage message="File cannot be uploaded." />, {
          hideProgressBar: true,
        });
      } finally {
        setLoader(false);
      }
    }
  };

  const uploadEvent = (event: any) => {
    let maxImageSize = 2048756;
    let img = new Image();
    img.src = window.URL.createObjectURL(event.target.files[0]);
    img.onload = async () => {
      if (
        event.target.name === "badgeHomeImg" &&
        event.target.files[0].size > maxImageSize
        //  ||
        // img.width > 750 ||
        // img.height > 120
      ) {
        toast.error(
          <ToastMessage message="Only JPEG or PNG files are allowed. Max size: 2MB." />,
          {
            hideProgressBar: true,
          }
        );
      } else if (
        event.target.name === "badgeProfileImg" &&
        event.target.files[0].size > maxImageSize
        // ||
        // img.width > 750 ||
        // img.height > 150
      ) {
        toast.error(
          <ToastMessage message="File size should be less than 2MB and dimension 750x150" />,
          {
            hideProgressBar: true,
          }
        );
      } else if (
        event.target.name === "bgHomeImg" &&
        event.target.files[0].size > maxImageSize
        // ||
        // img.width > 375 ||
        // img.height > 812
      ) {
        toast.error(
          <ToastMessage message="File size should be less than 2MB and dimension 375x812" />,
          {
            hideProgressBar: true,
          }
        );
      } else if (
        event.target.name === "bgMenuImg" &&
        event.target.files[0].size > maxImageSize
        // ||
        // img.width > 654 ||
        // img.height > 808
      ) {
        toast.error(
          <ToastMessage message="File size should be less than 2MB and dimension 654x808" />,
          {
            hideProgressBar: true,
          }
        );
      } else {
        setLoader(true);
        try {
          let { data } = await uploadEventImage(event.target.files[0]);
          setUploadedImage(data.files[0]);
          let formData = { ...accountDetails };
          // let formError = { ...error };
          if (event.target.name === "badgeHomeImg") {
            //@ts-ignore
            formData["badgeHomeImg"] = [];
            formData["badgeHomeImg"].push(data.files[0]);
            //@ts-ignore
            // formError["badgeHomeImg"] = "";
          }
          if (event.target.name === "badgeProfileImg") {
            //@ts-ignore
            formData["badgeProfileImg"] = [];
            formData["badgeProfileImg"].push(data.files[0]);
            //@ts-ignore
            // formError["badgeProfileImg"] = "";
          }
          if (event.target.name === "bgHomeImg") {
            //@ts-ignore
            formData["bgHomeImg"] = [];
            formData["bgHomeImg"].push(data.files[0]);
            //@ts-ignore
            // formError["bgHomeImg"] = "";
          }
          if (event.target.name === "bgMenuImg") {
            //@ts-ignore
            formData["bgMenuImg"] = [];
            formData["bgMenuImg"].push(data.files[0]);
            //@ts-ignore
            // formError["bgMenuImg"] = "";
          }
          setAccountDetails(formData);
          // setError(formError);
        } catch (error: any) {
          console.log(error);
          toast.error(<ToastMessage message="File cannot be uploaded." />, {
            hideProgressBar: true,
          });
        } finally {
          setLoader(false);
        }
      }
    };
  };

  const handlePDFRemove = () => {
    let formData = { ...accountDetails };
    formData["benefitsFile"] = [];
    setAccountDetails(formData);
  };

  const removeImage = (e: any) => {
    let formData = { ...accountDetails };
    // let formError = { ...error };
    //@ts-ignore
    formData.badgeHomeImg = formData.badgeHomeImg.filter(
      //@ts-ignore
      (each) => each.viewUrl !== e
    );
    //@ts-ignore
    formData.badgeProfileImg = formData.badgeProfileImg.filter(
      //@ts-ignore
      (each) => each.viewUrl !== e
    );
    formData.bgHomeImg = formData.bgHomeImg.filter(
      //@ts-ignore
      (each) => each.viewUrl !== e
    );
    formData.bgMenuImg = formData.bgMenuImg.filter(
      //@ts-ignore
      (each) => each.viewUrl !== e
    );
    setAccountDetails(formData);
    // setError(formError);
    setUploadedImage(undefined);
  };

  const handleSubmit = async () => {
    setLoader(true);
    if (validateAccountData(accountDetails, setFormError)) {
      try {
        if (id) {
          await updatePrivilege(
            getFormattedPostableAccountData(accountDetails),
            id
          );
        } else {
          await addPrivilege(getFormattedPostableAccountData(accountDetails));
        }
        navigate("/admin/privilege-account");
      } catch (err: any) {
        console.log(err);
        toast.error(err.message);
      } finally {
        setLoader(false);
      }
    } else {
      toast.error("Something went wrong!!! Please check all the fields.");
      setLoader(false);
    }
  };

  const handleCancel = () => {
    navigate("/admin/privilege-account");
  };

  return (
    <>
      <ManagePrivilegeAccountHeader
        isEdit={!!id}
        onBack={() => navigate("/admin/privilege-account")}
        data={accountDetails}
        onToggle={handleChange}
      />
      <PrivilegeAccountForm
        error={formError}
        data={accountDetails}
        onChange={handleChange}
        accountTypes={accountTypes}
        onAddMoreBenefits={handleAddMoreBenefits}
        uploadedImage={uploadedImage}
        onRemove={removeImage}
        onPDFRemove={handlePDFRemove}
        onSubmit={handleSubmit}
        onCancel={handleCancel}
      />
    </>
  );
};

export default ManagePrivilegeAccount;
